import {
  SelectField,
  Option,
  CreatableSelectField,
} from "src/features/calculator/components/field/SelectField"
import styled from "styled-components"
import { FormField } from "src/features/calculator/components/field/FormField"
import React from "react"
import {
  storesOptions,
  isRecipientOptions,
  nopOptions,
  paymentMethodOptions,
} from "src/features/calculator/utils/calculator"
import { DateInputField } from "src/features/calculator/components/field/DateInputField"
import { UseFormSetValue, UseFormWatch, FieldErrors } from "react-hook-form"
import { CalculationSchema } from "src/features/calculator/schema"

type Props = {
  setValue: UseFormSetValue<CalculationSchema>
  errors: FieldErrors<CalculationSchema>
  watch: UseFormWatch<CalculationSchema>
}

export function ApplicationInformation({ setValue, errors, watch }: Props) {
  const {
    adPrice,
    isRecipient,
    nop,
    paymentMethod,
    applicationId,
    userId,
    userName,
    storeId,
    storeName,
    scheduledDealAt,
    applicatedAt,
  } = watch()

  return (
    <StyledApplicationInformationDiv>
      <StyledHeading2>申請情報</StyledHeading2>
      <StyledRowDiv>
        <FormField
          label="申請ID"
          type="text"
          placeholder="123456"
          required
          errorText={errors?.applicationId?.message}
          onChange={(e) => {
            setValue("applicationId", e.target.value)
          }}
          defaultValue={applicationId}
        />
        <FormField
          onChange={(e) => {
            setValue("userId", e.target.value)
          }}
          label="ユーザーID"
          type="text"
          placeholder="123456"
          required
          errorText={errors?.userId?.message}
          defaultValue={userId}
        />
        <FormField
          onChange={(e) => {
            setValue("userName", e.target.value)
          }}
          label="ユーザー氏名"
          type="text"
          placeholder="タナカ タロウ"
          required
          errorText={errors?.userName?.message}
          defaultValue={userName}
        />
        <FormField
          onChange={(e) => {
            setValue("storeId", e.target.value)
          }}
          label="加盟店ID"
          type="text"
          placeholder="Placeholder"
          hint="※この項目は任意です"
          errorText={errors?.storeId?.message}
          defaultValue={storeId}
        />
        <CreatableSelectField
          name="storeName"
          label="加盟店名"
          options={storesOptions}
          hint="※この項目は任意です"
          onChange={(e: Option | null) => {
            if (typeof e.value === "string") {
              setValue("storeName", e.value)
            }
          }}
          errorText={errors?.storeName?.message}
          isSearchable
          defaultValue={
            storesOptions.find((option) => option.value === storeName) ||
            (storeName ? { value: storeName, label: storeName } : undefined)
          }
          width="250px"
        />
      </StyledRowDiv>
      <StyledRowDiv>
        <FormField
          defaultValue={adPrice}
          label="AD費用"
          type="number"
          placeholder="Placeholder"
          hint={adPrice ? `${adPrice}円` : "※この項目は任意です"}
          onChange={(e) => {
            setValue("adPrice", Number(e.target.value))
          }}
          errorText={errors?.adPrice?.message}
        />
        <SelectField
          name="isRecipient"
          label="店舗利用か？"
          options={isRecipientOptions}
          defaultValue={isRecipientOptions.find((option) => option.value === isRecipient)}
          hint="※この項目は任意です"
          onChange={(e: Option | null) => {
            if (e.value === "true" || e.value === "false") {
              setValue("isRecipient", e.value)
            }
          }}
          errorText={errors?.isRecipient?.message}
        />
        <SelectField
          name="nop"
          label="分割回数"
          options={nopOptions}
          defaultValue={nopOptions.find((option) => option.value === nop)}
          hint="※この項目は任意です"
          onChange={(e: Option | null) => {
            setValue("nop", Number(e.value))
          }}
          errorText={errors?.nop?.message}
        />
        <SelectField
          name="paymentMethod"
          label="支払い方法"
          options={paymentMethodOptions}
          defaultValue={paymentMethodOptions.find((option) => option.value === paymentMethod)}
          onChange={(e: Option | null) => {
            setValue("paymentMethod", Number(e.value))
          }}
          errorText={errors?.paymentMethod?.message}
          required
        />
        <DateInputField
          name="scheduledDealAt"
          onChange={(e) => {
            setValue("scheduledDealAt", e.target.value)
          }}
          label="振込予定日"
          placeholder="MM/DD/YYYY"
          errorText={errors?.scheduledDealAt?.message}
          required
          defaultValue={scheduledDealAt}
        />
      </StyledRowDiv>
      <StyledRowDiv>
        <DateInputField
          name="applicatedAt"
          label="審査申込日"
          placeholder="MM/DD/YYYY"
          errorText={errors?.applicatedAt?.message}
          required
          onChange={(e) => {
            setValue("applicatedAt", e.target.value)
          }}
          defaultValue={applicatedAt}
        />
      </StyledRowDiv>
    </StyledApplicationInformationDiv>
  )
}

const StyledHeading2 = styled.h2`
  font-size: 24px;
  margin-top: 20px;
  margin-bottom: 10px;
`

const StyledApplicationInformationDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const StyledRowDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`
